// extracted by mini-css-extract-plugin
module.exports = {"root":"StatusBar_root__1Kk7L","instance":"StatusBar_instance__3grGl"};